export default{
    unit:'واحد',
    unitTitle: 'عنوان',
    unitStatus: 'وضعیت',
    units:'واحدها',
    editUnit:'ویرایش واحد',
    addUnit:'واحد جدید',
    section :'جستجو براساس بخش',
    createAutomaticRecallNumber :'ایجاد اتوماتیک شماره فراخوانی',
    createCustomRecallNumber :'ایجاد دستی شماره فراخوانی',
}